<template>
  <q-card
    v-if="$app.whitelabel === 'alzura'"
    flat
    class="full-height column relative-position"
    :class="{ 'light-dimmed no-shadow': isConnected }"
  >
    <q-card-title>
      <div class="text-weight-medium flex items-center">
        <img src="@/assets/localOne.png" height="10">
        <div class="q-ml-xs"> Verbindung</div>
      </div>
      <span slot="subtitle">Verbinde Deinen local.one-Account, um Fahrzeuge auf der Plattform zu inserieren.</span>
    </q-card-title>
    <q-card-main class="q-pb-xs col" />
    <q-card-actions align="end" class="col-auto">
      <q-btn
        v-if="isConnected"
        color="positive"
        label="Verbunden"
        no-caps
        dense
        class="no-shadow no-pointer-events"
      />
      <q-btn
        v-else-if="isPending"
        color="faded"
        label="Freischaltung beantragt"
        outline
        no-caps
        dense
        class="no-shadow no-pointer-events"
      />
      <q-btn
        v-else
        color="primary"
        outline
        no-caps
        dense
        @click="unlock"
      >
        <q-spinner class="on-left" v-if="loading" />Verbinden
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LocalOneSetup',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('auth', ['currentBranch']),
    isConnected() {
      return !!this.currentBranch.localOneEnabled && !!this.currentBranch.localOneId;
    },
    isPending() {
      return !!this.currentBranch.localOneEnabled && !this.currentBranch.localOneId;
    },
  },
  methods: {
    async unlock() {
      this.loading = true;
      await this.$store.dispatch('branch/requestLocalOneActivation');
      await this.$store.dispatch('auth/reloadCurrentBranch');
      this.$notifyUserInteraction.success('Freischaltung beantragt!');
      this.loading = false;
    },
  },
};
</script>
